import _ from 'lodash';
import { evaluateConditions } from '../condition-engine/evaluateConditions';
import { evaluateQuery } from '../condition-engine/queries';
import { BooleanOperators } from '../types/carrierQuestionnaire/conditions/operators';
import { ExpandedRepetitionsVisitor } from './expandedContext/ExpandedRepetitionsVisitor';
import { filterVisibleAnswers } from './nodeEvaluation/visibleIf/filterVisibleAnswers';
class ComputedAnswersVisitor extends ExpandedRepetitionsVisitor {
    visibilityDependencyMap;
    changedNodeInstances = [];
    timezone;
    answersResolver; // This is shadowing the base class property because it requires more permission here.
    currentDateOverride;
    constructor(answersResolver, visibilityDependencyMap, timezone, currentDateOverride) {
        super(answersResolver);
        this.answersResolver = answersResolver;
        this.visibilityDependencyMap = visibilityDependencyMap;
        this.timezone = timezone;
        this.currentDateOverride = currentDateOverride;
    }
    setComputedAnswers(questionnaire) {
        this.visitQuestionnaire(questionnaire);
        return;
    }
    getChangedNodeInstances() {
        return _.uniqWith(this.changedNodeInstances, _.isEqual);
    }
    visitField(field) {
        const { blueprintId, computedValue } = field;
        if (!computedValue) {
            return;
        }
        const scopes = this.repeatedInstanceIdentifiers();
        if (!this.isFieldVisible(field, scopes.byNodeId)) {
            return;
        }
        const computedFieldValue = evaluateQuery(computedValue, this.answersResolver, scopes.byNodeId, this.timezone, {}, this.currentDateOverride);
        const currentAnswer = this.answersResolver.getAnswer(blueprintId, scopes.byBlueprintId);
        if (computedFieldValue === currentAnswer) {
            return;
        }
        this.answersResolver.setAnswer(computedFieldValue, blueprintId, scopes.byBlueprintId);
        this.changedNodeInstances.push({
            byBlueprintId: {
                blueprintId: blueprintId,
                blueprintIdScope: scopes.byBlueprintId,
            },
            byNodeId: {
                nodeId: field.nodeId,
                nodeIdScope: scopes.byNodeId,
            },
        });
    }
    isFieldVisible(field, scope) {
        let fieldVisibilityConditions = undefined;
        if (field.nodeId) {
            fieldVisibilityConditions = this.visibilityDependencyMap.getVisibilityConditions(field.nodeId);
        }
        let visibilityConditions = undefined;
        if (fieldVisibilityConditions) {
            visibilityConditions = fieldVisibilityConditions?.field;
        }
        const isFieldVisible = !visibilityConditions ||
            evaluateConditions({ conditions: visibilityConditions, operator: BooleanOperators.or }, this.answersResolver, scope, this.timezone, this.currentDateOverride).isValid;
        return isFieldVisible;
    }
}
export function computedQuestionnaireAnswers(questionnaire, answersResolver, dependencyMap, timezone, currentDateOverride) {
    const computedAnswersVisitor = new ComputedAnswersVisitor(answersResolver, dependencyMap, timezone, currentDateOverride);
    computedAnswersVisitor.setComputedAnswers(questionnaire);
    // Setting computed answers may affect the visibility of other answers.
    for (const nodeInstance of computedAnswersVisitor.getChangedNodeInstances()) {
        if (nodeInstance.byNodeId.nodeId) {
            filterVisibleAnswers(nodeInstance.byNodeId.nodeId, dependencyMap, answersResolver, nodeInstance.byNodeId.nodeIdScope, timezone, currentDateOverride);
        }
    }
}
